/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit OverrideChairSchedule/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TimegridOverrideTemplate from 'DesignSystem/TimegridOverrideTemplate/index'



/** @type {import('Simple/types.js').View} */
export default function OverrideChairSchedule({
  children,
  viewPath = "/DesignSystem/TimeGrid/FullCalendarTimegrid/SlotDialog/Content/Content/OverrideChairSchedule",
  onClose
  
}) {
let slotDialogScheduleNoteValueData = fromData.useDataValue({ viewPath,
context: 'slot_dialog',
path: 'schedule_note',
})
  return (<React.Fragment
>
<TimegridOverrideTemplate
  viewPath={`${viewPath}/TimegridOverrideTemplate`}
 data="slot_dialog.schedule_note"
 resource={slotDialogScheduleNoteValueData}
 onComplete={onClose}
/>
{children}
</React.Fragment>)
}